GloboSwatchConfig.settings = {
            enable_collection_page: true,
            enable_product_page: false,
            out_of_stock: "hide",
            enable_mandatory: false,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: true,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false,
            show_one_variant_product: false,
            show_one_variant_collection: false,
            group_image: false,
            show_limit_variant: false,
            limit_variant: "5",
        };
        GloboSwatchConfig.options = [{"id":70300,"name":"Title","shop_id":12259,"option_items":[{"id":1741514,"value":"Default Title","option_id":70300,"products":null,"products_count":23,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":2,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":23,"order":1},{"id":70301,"name":"Color","shop_id":12259,"option_items":[{"id":1741515,"value":"Blanco","option_id":70301,"products":null,"products_count":15,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1741516,"value":"Rosa","option_id":70301,"products":null,"products_count":15,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1741517,"value":"Negro","option_id":70301,"products":null,"products_count":15,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":2,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":15,"order":2}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#d408bc',
                        selected: '#c810ce'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#FFFFFF',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#000000',
                        hover: '#d3198e',
                        selected: '#ce1898'
                    },
                    hover_effects:{
                        background: 'add glow',
                        zoom_image: 'zoom',
                        size_change: 'increase size'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000',
                        selected: '#000'
                    },
                    text_style: 'uppercase',
                    text_color: {
                        normal: '#000',
                        hover: '#ffffff',
                        selected: '#fff'
                    },
                    background_color: {
                        normal: '#fff',
                        hover: '#000000',
                        selected: '#000'
                    },
                    hover_effects:{
                        background: 'add glow',
                    }
                },
                float: 'left',
                carousel: 'disable'
        };